import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Privarcy() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained" bis_skin_checked="1">
        <p>Τελευταία ενημέρωση: 20 Φεβρουαρίου 2025</p>
        
        <p>Το https://grsocialge.site (“εμείς” ή “μας”) διαχειρίζεται τον ιστότοπο https://grsocialge.site (η "Υπηρεσία").</p>
        
        <p>Αυτή η σελίδα σας ενημερώνει για τις πολιτικές μας σχετικά με τη συλλογή, χρήση και κοινοποίηση Προσωπικών Δεδομένων όταν χρησιμοποιείτε την Υπηρεσία μας.</p>
        
        <p>Δεν θα χρησιμοποιήσουμε ή κοινοποιήσουμε τις πληροφορίες σας σε κανέναν, εκτός από όσα περιγράφονται σε αυτήν την Πολιτική Απορρήτου.</p>
        
        <p>Χρησιμοποιούμε τα Προσωπικά σας Δεδομένα για να παρέχουμε και να βελτιώνουμε την Υπηρεσία. Χρησιμοποιώντας την Υπηρεσία, συμφωνείτε με τη συλλογή και χρήση πληροφοριών σύμφωνα με αυτήν την πολιτική. Εκτός εάν ορίζεται διαφορετικά, οι όροι που χρησιμοποιούνται σε αυτήν την Πολιτική Απορρήτου έχουν την ίδια έννοια με τους Όρους και Προϋποθέσεις μας, οι οποίοι είναι διαθέσιμοι στο https://grsocialge.site</p>
        
        <h2 className="wp-block-heading">Συλλογή και Χρήση Πληροφοριών</h2>
        
        <p>Κατά τη χρήση της Υπηρεσίας μας, ενδέχεται να σας ζητήσουμε να μας παρέχετε ορισμένες προσωπικά αναγνωρίσιμες πληροφορίες που μπορούν να χρησιμοποιηθούν για την επικοινωνία ή την ταυτοποίησή σας. Τα προσωπικά δεδομένα ("Προσωπικές Πληροφορίες") μπορεί να περιλαμβάνουν, αλλά δεν περιορίζονται σε:</p>
        
        <h2 className="wp-block-heading">Δεδομένα Καταγραφής</h2>
        
        <p>Συλλέγουμε πληροφορίες που στέλνει το πρόγραμμα περιήγησής σας κάθε φορά που επισκέπτεστε την Υπηρεσία μας ("Δεδομένα Καταγραφής"). Αυτά μπορεί να περιλαμβάνουν τη διεύθυνση IP του υπολογιστή σας, τον τύπο του προγράμματος περιήγησης, την έκδοση του προγράμματος περιήγησης, τις σελίδες που επισκέπτεστε στην Υπηρεσία μας, την ώρα και την ημερομηνία της επίσκεψής σας, τον χρόνο που δαπανάται σε αυτές τις σελίδες και άλλα στατιστικά στοιχεία.</p>
        
        <h2 className="wp-block-heading">Cookies</h2>
        
        <p>Τα cookies είναι αρχεία που περιέχουν μικρή ποσότητα δεδομένων, τα οποία μπορεί να περιλαμβάνουν έναν ανώνυμο μοναδικό αναγνωριστικό. Τα cookies αποστέλλονται στον περιηγητή σας από έναν ιστότοπο και αποθηκεύονται στον σκληρό δίσκο του υπολογιστή σας.</p>
        
        <p>Χρησιμοποιούμε “cookies” για τη συλλογή πληροφοριών. Μπορείτε να ρυθμίσετε τον περιηγητή σας ώστε να αρνείται όλα τα cookies ή να υποδεικνύει πότε αποστέλλεται ένα cookie. Ωστόσο, αν δεν αποδεχτείτε τα cookies, ενδέχεται να μην μπορείτε να χρησιμοποιήσετε ορισμένα τμήματα της Υπηρεσίας μας.</p>
        
        <h2 className="wp-block-heading">Πάροχοι Υπηρεσιών</h2>
        
        <p>Ενδέχεται να προσλάβουμε τρίτες εταιρείες και άτομα για να διευκολύνουν την Υπηρεσία μας, να παρέχουν την Υπηρεσία για λογαριασμό μας, να εκτελούν συναφείς υπηρεσίες ή να μας βοηθούν στην ανάλυση του τρόπου χρήσης της Υπηρεσίας μας.</p>
        
        <p>Αυτά τα τρίτα μέρη έχουν πρόσβαση στα Προσωπικά σας Δεδομένα μόνο για να εκτελέσουν αυτές τις εργασίες για λογαριασμό μας και είναι υποχρεωμένα να μην τα κοινοποιούν ή να τα χρησιμοποιούν για οποιονδήποτε άλλο σκοπό.</p>
        
        <h2 className="wp-block-heading">Ασφάλεια</h2>
        
        <p>Η ασφάλεια των Προσωπικών σας Δεδομένων είναι σημαντική για εμάς, αλλά να θυμάστε ότι καμία μέθοδος μετάδοσης μέσω του Διαδικτύου ή μέθοδος ηλεκτρονικής αποθήκευσης δεν είναι 100% ασφαλής. Αν και προσπαθούμε να χρησιμοποιήσουμε εμπορικά αποδεκτά μέσα για την προστασία των Προσωπικών σας Δεδομένων, δεν μπορούμε να εγγυηθούμε την απόλυτη ασφάλεια.</p>
        
        <p>Δεν έχουμε έλεγχο και δεν αναλαμβάνουμε καμία ευθύνη για το περιεχόμενο, τις πολιτικές απορρήτου ή τις πρακτικές οποιωνδήποτε ιστότοπων ή υπηρεσιών τρίτων.</p>
        
        <h2 className="wp-block-heading">Απόρρητο Παιδιών</h2>
        
        <p>Η Υπηρεσία μας δεν απευθύνεται σε άτομα κάτω των 18 ετών ("Παιδιά").</p>
        
        <p>Δεν συλλέγουμε εν γνώσει μας προσωπικά αναγνωρίσιμες πληροφορίες από παιδιά κάτω των 18 ετών. Εάν είστε γονέας ή κηδεμόνας και γνωρίζετε ότι το παιδί σας μας έχει παράσχει Προσωπικά Δεδομένα, επικοινωνήστε μαζί μας. Εάν ανακαλύψουμε ότι παιδί κάτω των 18 ετών μας έχει παράσχει Προσωπικά Δεδομένα, θα διαγράψουμε αμέσως αυτές τις πληροφορίες από τους διακομιστές μας.</p>
        
        <h2 className="wp-block-heading">Αλλαγές στην Πολιτική Απορρήτου</h2>
        
        <p>Ενδέχεται να ενημερώνουμε την Πολιτική Απορρήτου μας κατά καιρούς. Θα σας ειδοποιήσουμε για οποιεσδήποτε αλλαγές δημοσιεύοντας τη νέα Πολιτική Απορρήτου σε αυτήν τη σελίδα.</p>
        
        <p>Συνιστάται να ελέγχετε περιοδικά αυτήν την Πολιτική Απορρήτου για τυχόν αλλαγές. Οι αλλαγές σε αυτήν την Πολιτική Απορρήτου ισχύουν από τη στιγμή που δημοσιεύονται σε αυτήν τη σελίδα.</p>
        
        <h2 className="wp-block-heading">Ανάλυση Δεδομένων</h2>
        
        <p>Το Roulette Rush Game διατηρεί το δικαίωμα να χρησιμοποιεί τα προσωπικά σας δεδομένα για σκοπούς ανάλυσης. Αυτή η ανάλυση περιλαμβάνει την ταξινόμηση και την κατάρτιση προφίλ χρηστών για την καλύτερη στόχευση του μάρκετινγκ.</p>
        
        <h2 className="wp-block-heading">Επικοινωνία</h2>
        
        <p>Εάν έχετε οποιαδήποτε ερώτηση σχετικά με αυτήν την Πολιτική Απορρήτου, παρακαλούμε επικοινωνήστε μαζί μας.</p>
    </div>
</div>

    <Footer/>
    
    </>
  )
}

export default Privarcy